/*
 * Copyright (c) 2025.  chad and contributors.
 * All rights reserved.
 */

export function debounce<T extends (...args: any[]) => any>(
    func: T,
    wait: number = 300,
    immediate: boolean = false
): ((...args: Parameters<T>) => void) & { cancel: () => void } {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const debounced = function (...args: Parameters<T>) {
        const later = () => {
            timeoutId = null;
            if (!immediate) {
                func(...args);
            }
        };

        const shouldCallNow = immediate && !timeoutId;
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(later, wait);

        if (shouldCallNow) {
            func(...args);
        }
    };

    debounced.cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };

    return debounced;
}